export default "__VITE_ASSET__f8238047__"